import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The old `journeys` URL for the native data-out connectors (mixpanel, amplitude), which the
// integrations directory still links to. The page lives at
// `/workspaces/:workspaceId/integrations/data_out/:type`.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/data_out/$type')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/integrations/data_out/:type'),
});
